import { useConfig } from '../../config';
import { useFormatting, useTranslation } from '../../i18n/i18n';
import { useSession } from '../../state/session';
import { Icon, coins, gift, stats_chart } from '../Icon/Icon';
import { InfoCard } from '../InfoCard/InfoCard';
import './InfoCardBoard.css';

type InfoCardBoardProps = {
	bonusBalance: number;
	specialPricesProductCount: number;
	totalOrderVolume: number;
};

export const InfoCardBoard = ({ bonusBalance, specialPricesProductCount, totalOrderVolume }: InfoCardBoardProps) => {
	const t = { ...useTranslation().myPages, ...useTranslation().routes, ...useTranslation().product.units };
	const { asPrice } = useFormatting();
	const { currencyCode } = useConfig();
	const { user } = useSession();

	return (
		<div className="board-grid">
			<InfoCard
				smallText={t.myBonus}
				text={asPrice(bonusBalance, currencyCode === 'EUR' ? 2 : 0)}
				link={t.bonus}
				icon={<Icon shape={gift} size={88} />}
			/>
			<InfoCard
				smallText={t.totalOrderVolume}
				text={asPrice(totalOrderVolume, currencyCode === 'EUR' ? 2 : 0)}
				link={t.yourOrders}
				icon={<Icon shape={stats_chart} size={88} />}
			/>
			{!!user?.specials ? (
				<InfoCard
					smallText={t.mySpecialPrices}
					text={`${specialPricesProductCount} ${t.st}`}
					link={t.specialPrices2}
					icon={<Icon shape={coins} size={88} />}
				/>
			) : null}
			{/* <InfoCard
				smallText={t.saveTimeWithSubscriptions}
				text={t.create}
				link={t.subscriptions}
				icon={<Icon shape={arrows_clockwise} size={88} />}
			/> */}
		</div>
	);
};
